document.addEventListener('DOMContentLoaded', () => {
  const swatchWrappers = document.querySelectorAll('.card-swatch-wrapper');

  swatchWrappers.forEach(wrapper => {
    const swatches = wrapper.querySelectorAll('.card-swatch');
    
    // Reads the product ID from the parent element.
    const productId = wrapper.closest('.card-variant-options')?.dataset.productId;
    
    if (!productId || swatches.length === 0) {
      return; 
    }

    const mainImage = document.querySelector(`img[data-main-image="${productId}"]`);

    if (!mainImage) {
      return;
    }

    swatches.forEach(swatch => {
      // Ensure we don't add listeners to the "+N" link
      if (swatch.classList.contains('card-swatch--more')) return;

      swatch.addEventListener('click', (event) => {
        event.preventDefault();
        
        const newSrc = swatch.dataset.variantImageSrc;
        const newSrcset = swatch.dataset.variantImageSrcset;

        if (newSrc && newSrcset) {
          mainImage.src = newSrc;
          mainImage.srcset = newSrcset;
        }
        
        // Reset all swatch styles
        wrapper.querySelectorAll('.card-swatch').forEach(s => s.style.boxShadow = 'none');
        // Apply active style
        swatch.style.boxShadow = '0 0 0 2px white, 0 0 0 4px black';
      });
    });
  });
});